const serviceSchema = (service, slug) => {
  if (!service) return null;

  const serviceUrl = `https://ldlsettlementservices.com.au/services/${slug}`;

  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${serviceUrl}#service`,

    "name": service.heroTitle || service.title,

    "description": service.heroDesc || service.metaDesc,

    "url": serviceUrl,

    "provider": {
      "@type": "LocalBusiness",
      "@id": "https://ldlsettlementservices.com.au/#business",
      "name": "LDL Settlement Services"
    },

    "areaServed": {
      "@type": "AdministrativeArea",
      "name": "Western Australia"
    }
  };
};

export default serviceSchema;